/**
 * useMyAccountModal — "내 계정·환경" 모달 열기·닫기(어디서든).
 *
 * 계정 메뉴(PC)·계정 시트(MO)·법인 환경설정 안내(C-3 [내 계정·환경 열기]) 등 여러 곳에서 연다.
 * Context 대신 모듈 상태 + useSyncExternalStore — Provider 없이 Layout 이 모달을 한 번만 그린다.
 */
import { useSyncExternalStore } from "react";

export type MyAccountTab = "profile" | "notify" | "home" | "devices";
export const MY_ACCOUNT_TABS: readonly MyAccountTab[] = ["profile", "notify", "home", "devices"] as const;

export interface MyAccountModalState {
  open: boolean;
  /** MO 에서 null = 루트 목록(D-4), PC 에서는 null 이면 회원정보 */
  tab: MyAccountTab | null;
}

let state: MyAccountModalState = { open: false, tab: null };
const listeners = new Set<() => void>();

function emit(next: MyAccountModalState) {
  state = next;
  listeners.forEach((l) => l());
}

/** 모달 열기 — tab 을 주면 그 탭으로 바로 */
export function openMyAccount(tab: MyAccountTab | null = null): void {
  emit({ open: true, tab });
}
export function closeMyAccount(): void {
  emit({ open: false, tab: state.tab });
}
export function setMyAccountTab(tab: MyAccountTab | null): void {
  emit({ ...state, tab });
}

function subscribe(cb: () => void) {
  listeners.add(cb);
  return () => listeners.delete(cb);
}
function snapshot() {
  return state;
}

export function useMyAccountModal() {
  const s = useSyncExternalStore(subscribe, snapshot, snapshot);
  return { ...s, openMyAccount, closeMyAccount, setTab: setMyAccountTab };
}
